import { css } from '@emotion/react'
import { typo } from '@mathflat/common/style'

const S = {
  modal: css`
    width: 600px;
    height: 620px;
  `,
  header: css`
    display: flex;
    align-items: center;
    height: 72px;
    padding: 24px;
    border-bottom: 1px solid var(--Colors-Gray-400);
    > .title {
      flex-shrink: 0;
      font-weight: 700;
      ${typo.heading05};
    }
    > sub {
      margin: 0 24px 0 12px;
      color: var(--Colors-Gray-700);
      ${typo.body02};
    }
  `,
  body: css`
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 16px;
    min-height: 0;
    padding: 16px 24px 0;
    .tabs-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 12px;
    }
    .tabs {
      display: flex;
      gap: 10px;
      /* RadioGroup 기본 스타일이 라벨마다 좌우 4px 마진을 줘서 gap 과 겹친다. 간격은 gap 하나로만 잡는다 */
      > label {
        margin: 0;
      }
    }
    .count {
      color: var(--Colors-Gray-700);
      ${typo.body02};
    }
    .list {
      display: flex;
      flex: 1;
      flex-direction: column;
      gap: 16px;
      min-height: 0;
      padding-bottom: 16px;
      overflow-y: auto;
    }
    .center {
      display: flex;
      flex: 1;
      align-items: center;
      justify-content: center;
    }
    .empty,
    .error {
      color: var(--Colors-Gray-600);
      ${typo.body02};
    }
    .error {
      flex-direction: column;
      gap: 12px;
    }
    .sentinel {
      flex-shrink: 0;
      height: 1px;
    }
  `,
  chip: css`
    height: 40px;
    padding: 0 16px;
    border-radius: var(--Radius-Circle);
    color: var(--Colors-Gray-900);
    ${typo.body02};
  `,
  footer: css`
    display: flex;
    padding: 16px 24px 20px;
  `,
}

export default S
